import * as React from 'react';

import { useIntl } from 'react-intl';

import { RecentItemsCarousel } from 'components/recent-items-carousel';
import useLocation from 'hooks/location/use-location';
import useEffectOnce from 'hooks/use-effect-once';
import { useRecentItemsAvailable } from 'hooks/use-recent-items-available';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

import {
  MenuRecentItemsInnerWrapper,
  MenuRecentItemsTitle,
  MenuRecentItemsWrapper,
} from './menu-recent-items.styled';

const MenuRecentItems = () => {
  const { formatMessage } = useIntl();
  const {
    location: { pathname },
  } = useLocation();
  const { refreshCurrentUserWithNewSession } = useAuthContext();

  // Make sure the flag is turned ON, the user is at the /menu route and the user has recent items available
  const [enableRecentItemsInMenu, isAtTheMainMenu, recentItemsAvailable] = [
    useFlag(LaunchDarklyFlag.ENABLE_RECENT_ITEMS_IN_MENU),
    pathname === routes.menu,
    useRecentItemsAvailable(),
  ];

  useEffectOnce(() => {
    refreshCurrentUserWithNewSession();
  });

  const showMenuRecentItems = enableRecentItemsInMenu && recentItemsAvailable && isAtTheMainMenu;

  return showMenuRecentItems ? (
    <MenuRecentItemsWrapper data-testid="menu-recent-items">
      <MenuRecentItemsInnerWrapper>
        <MenuRecentItemsTitle>{formatMessage({ id: 'recentItems' })}</MenuRecentItemsTitle>
        <RecentItemsCarousel containerHasTopPadding={false} locationName="Menu" />
      </MenuRecentItemsInnerWrapper>
    </MenuRecentItemsWrapper>
  ) : null;
};

export default MenuRecentItems;
